import { proxy } from 'valtio';
import { Organization } from '../shared/models/organization.model';

export const organizationStore = proxy({

    organizationList: [] as Organization[],
    showCreateModal: false,
    modalDeleteVisible : false,
	isDeleting :false,
    pendingParentId: null as number | null,
    organziationSelected: new Organization,
    setOrganizations: (value: Organization[]) => {
        organizationStore.organizationList = value;
    },
    setModalTemplateVisibility:(value: boolean) => {
        organizationStore.showCreateModal = value;
        if (!value) {
            organizationStore.pendingParentId = null;
        }
    },
    openCreateModalWithParent: (parentId: number | null) => {
        organizationStore.pendingParentId = parentId;
        organizationStore.showCreateModal = true;
    },
    setModalDeleteVisible:(value: boolean) => {
        organizationStore.modalDeleteVisible = value;
    },
    setIsdeleting:(value: boolean) => {
        organizationStore.isDeleting = value;
    },
    selectOrganization: (value: Organization) => {
        organizationStore.organziationSelected = value
    }

});